import { render, staticRenderFns } from "./cadastro_edicao_unidade.vue?vue&type=template&id=194f2ff4&scoped=true"
import script from "./cadastro_edicao_unidade.vue?vue&type=script&lang=js"
export * from "./cadastro_edicao_unidade.vue?vue&type=script&lang=js"
import style0 from "./cadastro_edicao_unidade.vue?vue&type=style&index=0&id=194f2ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f2ff4",
  null
  
)

export default component.exports